import React, {useCallback} from 'react';

export const ScrollLink = (props) => {
  const {to, children} = props;

  const navigate = useCallback(
    () => {
      document.getElementById(to).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
      // scrollTo({id: to, duration});
    },
    [to],
  );

  return (
    <a {...props} onClick={navigate}>
      {children}
    </a>
  );
};

ScrollLink.propTypes = {}

ScrollLink.defaultProps = {}

export default ScrollLink;